<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="#ac8a2e"
          inline
          title="Staff"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="nombre"
                      rules="required|max:45"
                    >
                      <v-text-field
                        v-model="dataForm.user.name"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Nombre"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="apellido"
                      rules="max:45"
                    >
                      <v-text-field
                        v-model="dataForm.user.lastname"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Apellido"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="dni"
                      rules="required|max:10"
                    >
                      <v-text-field
                        v-model="dataForm.user.dni"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Dni"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="celular"
                      rules="max:25"
                    >
                      <v-text-field
                        v-model="dataForm.user.celular"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Celular"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="email"
                      rules="max:45|email"
                    >
                      <v-text-field
                        v-model="dataForm.user.email"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Email"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="domicilio"
                      rules="required|max:45"
                    >
                      <v-text-field
                        v-model="dataForm.user.domicilio"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Domicilio"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="cargo"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="dataForm.cargo_id"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Cargo"
                        item-value="id"
                        item-text="descripcion"
                        :items="cargos"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item
                            v-bind="attrs"
                            active-class="secondary elevation-4 white--text"
                            class="mx-3 mb-3 v-sheet"
                            elevation="0"
                            v-on="on"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider
                          v-slot="{ errors }"
                          name="fecha ingreso"
                          rules="required"
                        >
                          <v-text-field
                            v-model="dataForm.fecha_ingreso"
                            color="#ac8a2e"
                            :error-messages="errors"
                            label="Fecha ingreso"
                            readonly
                            v-on="on"
                          />
                        </validation-provider>
                      </template>
                      <v-date-picker v-model="dataForm.fecha_ingreso" color="#ac8a2e" landscape scrollable no-title locale="es-419" @input="menu = false" />
                    </v-menu>
                  </v-col>

                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="descripcion"
                      rules="max:250"
                    >
                      <v-textarea
                        v-model="dataForm.user.obs"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Observaciones"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="space-between">
                      <v-checkbox v-if="mode !=='show'" v-model="notificar" :disabled="!showNotificar" color="#ac8a2e" label="Notificar al guardar" class="ml-3" />
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-card
          class="v-card--material pa-3"
        >
          <div class="d-flex grow flex-wrap">
            <v-avatar size="128" class="mx-auto v-card--material__avatar elevation-6" color="grey">
              <base-upload-files folder="/users" tipo="imagen" :documento-id="dataForm.user.documentacion_id" public avatar @documento="dataForm.user.documentacion_id = $event" />
            </v-avatar>
          </div>
          <v-card-text class="text-center">
            <h6 class="display-1 mb-1 grey--text">
              {{ cargo.descripcion }}
            </h6>

            <h4 class="display-2 font-weight-light mb-3 black--text">
              {{ dataForm.user.name }} &nbsp;  {{ dataForm.user.lastname }}
            </h4>

            <p class="font-weight-light grey--text">
              {{ dataForm.user.obs }}
            </p>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-subtitle>Roles y permisos</v-card-subtitle>
          <v-divider />
          <v-row class="pa-4">
            <v-col
              cols="12"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nombre padre"
                rules="required"
              >
                <v-select
                  v-model="dataForm.user.rolese"
                  :items="roles"
                  :error-messages="errors"
                  attach
                  chips
                  label="Roles"
                  multiple
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
            >
              <v-autocomplete
                v-model="dataForm.user.permisos"
                :items="permissions"
                attach
                chips
                label="Permisos"
                multiple
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo usuario',
      cargos: [],
      menu: false,
      showNotificar: false,
      notificar: false,
      roles: [],
      permissions: [],
      dataForm: {
        id: '',
        fecha_ingreso: '',
        cargo_id: '',
        user: {
          id: '',
          dni: '',
          name: '',
          lastname: '',
          domicilio: '',
          celular: '',
          email: '',
          obs: '',
          permissions: [],
          roles: [],
          documentacion_id: 0,
        },
      },
    }),
    computed: {
      cargo: function () {
        return this.cargos.find(cargo => cargo.id === this.dataForm.cargo_id) || ''
      },
    },
    watch: {
      'dataForm.user.email' (val) {
        if (val === '') {
          this.showNotificar = false
        } else {
          this.showNotificar = true
        }
      },
    },
    created () {
      // this.$store.commit('loaderOn', 1)
      this.setTittle()
      if (this.mode !== 'new') {
        this.getMiembro()
      }
      this.getCargos()
      this.getRoles()
      this.getPermissions()
    },
    methods: {
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo usuario'
        } else if (this.mode === 'show') {
          this.tittle = 'Informacion usuario'
        } else {
          this.tittle = 'Editar usuario'
        }
      },
      getCargos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/cargos_get' }).then(response => { this.cargos = response })
      },
      getMiembro: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get/' + this.id }).then(response => { this.dataForm = response })
      },
      getRoles: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/role_names_get/' }).then(response => { this.roles = response })
      },
      getPermissions: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/permisos_get/' }).then(response => { this.permissions = response })
      },
      validateForm (scope) {
        this.enviarStaff()
      },
      enviarStaff: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/staff_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de usuario exitosa'] })
          if (this.dataForm.user.email != null && this.dataForm.user.email !== '' && this.notificar) {
            this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
          }
          this.$router.push({ name: 'Staff' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/staff_agregar',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de usuario exitosa'] })
          if (this.dataForm.user.email != null && this.dataForm.user.email !== '' && this.notificar) {
            this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
          }
          this.$router.push({ name: 'Staff' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },

    },
  }
</script>
